import * as navigation from 'Navigation';

export default class ProcessTaskDetailsOutputsTabState extends navigation.TabState {
  override defaults(): navigation.TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Outputs',
      closeable: false,
      preferenceKey: 'process-task-outputs',
    };
  }
}
